import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import bgTech from '../assets/background-tech.webp';
import Footer from '../components/Footer';

const featureCards = [
  {
    title: 'Find Bursaries',
    desc: 'Discover funding opportunities tailored for you.',
    icon: '💡',
    action: 'Browse Now',
    to: '/financial-institutions',
  },
  {
    title: 'Smart Application Tips',
    desc: 'Use data-driven tips to boost your success rate.',
    icon: '⚙️',
    action: 'Learn Tips',
    to: '/career-suggester',
  },
  {
    title: 'AI Profile Boost',
    desc: 'Personalized recommendations powered by smart tech.',
    icon: '🤖',
    action: 'Optimize Profile',
    to: '/learn-more',
  },
];

function Home() {
  const [width, setWidth] = useState(window.innerWidth);
  const navigate = useNavigate();
  useEffect(() => {
    const resize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  return (
    <div style={{
      paddingTop: '70px',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, rgba(15,32,39,0.90) 0%, rgba(44,83,100,0.82) 40%, rgba(67,206,162,0.68) 100%)',
      transition: 'background 0.5s',
    }}>
      {/* Hero Banner */}
      <div style={{
        width: '100%',
        minHeight: width > 700 ? 340 : 220,
        background: 'linear-gradient(135deg, rgba(15,32,39,0.90) 0%, rgba(44,83,100,0.82) 40%, rgba(67,206,162,0.68) 100%)',
        backgroundSize: '200% 200%',
        animation: 'gradientMove 6s ease-in-out infinite',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
        padding: '50px 20px 40px 20px',
        borderRadius: 0,
        boxShadow: '0 8px 32px #2a529866',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <style>{`
          @keyframes gradientMove {
            0% {background-position: 0% 50%;}
            50% {background-position: 100% 50%;}
            100% {background-position: 0% 50%;}
          }
          .exciting-cta {
            background: linear-gradient(90deg,#ffb347,#ffcc33,#1e3c72,#2a5298);
            color: #fff;
            border: none;
            border-radius: 24px;
            padding: 14px 38px;
            font-size: 1.2em;
            font-weight: 700;
            margin-top: 24px;
            margin-bottom: 6px;
            box-shadow: 0 4px 16px #1e3c7240;
            cursor: pointer;
            transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
            letter-spacing: 1px;
          }
          .exciting-cta:hover {
            transform: scale(1.07);
            background: linear-gradient(135deg, rgba(15,32,39,0.90) 0%, rgba(44,83,100,0.82) 40%, rgba(67,206,162,0.68) 100%);
            box-shadow: 0 8px 24px #2a529899;
          }
          .exciting-tagline {
            animation: fadeInUp 1.3s cubic-bezier(.63,-0.13,.54,1.34);
          }
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(32px); }
            100% { opacity: 1; transform: translateY(0); }
          }
        `}</style>
        <div>
          <h1 style={{
            fontSize: width > 700 ? 48 : 28,
            fontWeight: 700,
            marginBottom: 10,
            letterSpacing: 1.2,
            textShadow: '0 4px 20px #1e3c7299, 0 1px 0 #fff2',
            background: 'linear-gradient(90deg,#fff,#ffb347,#2a5298)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
            position: 'relative',
          }}>
            <span role="img" aria-label="spark">✨</span> Welcome to <span style={{color:'#ffb347',WebkitTextFillColor:'#ffb347'}}>Zazi</span> <span role="img" aria-label="rocket">🚀</span>
          </h1>
          <div className="exciting-tagline" style={{ color: '#fff', fontSize: width > 700 ? 22 : 15, marginBottom: 18, fontWeight: 500, textShadow: '0 2px 8px #0009', letterSpacing: 0.2 }}>
            Track and manage your <span style={{color:'#ffcc33'}}>tertiary education</span> and <span style={{color:'#ffb347'}}>financial aid</span> applications here.
          </div>
          <button className="exciting-cta" onClick={()=>navigate('/dashboard')}>Get Started</button>

          <h1 style={{
            fontSize: width > 700 ? 42 : 26,
            fontWeight: 600,
            marginBottom: 10,
            letterSpacing: 1.2,
            textShadow: '0 2px 12px #0007, 0 1px 0 #fff2',
            color: '#fff'
          }}>
            Empowering the Future
          </h1>
          <p style={{
            fontSize: width > 700 ? 20 : 16,
            maxWidth: 600,
            margin: '0 auto',
            color: 'rgba(255,255,255,0.93)',
            letterSpacing: 0.5,
            textShadow: '0 1px 8px #0005'
          }}>
            Find bursaries, get smart advice, and upgrade your journey with tech-driven tools.
          </p>
        </div>
      </div>

      {/* Feature Cards */}
      <div style={{
        display: 'flex',
        flexDirection: width > 800 ? 'row' : 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 30,
        padding: '40px 20px',
        maxWidth: 1100,
        margin: '0 auto',
      }}>
        {featureCards.map((card) => (
          <div key={card.title} style={{
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
            padding: '30px 24px',
            width: width > 800 ? '30%' : '100%',
            textAlign: 'center',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            cursor: 'pointer',
            marginBottom: 30,
          }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
            }}>
            <div style={{ fontSize: 48, marginBottom: 16, color: '#203a43' }}>{card.icon}</div>
            <h3 style={{ fontSize: 22, marginBottom: 10, color: '#203a43' }}>{card.title}</h3>
            <p style={{ fontSize: 15, color: '#555', marginBottom: 20 }}>{card.desc}</p>
            <button
              style={{
                background: '#203a43',
                color: '#fff',
                padding: '10px 22px',
                border: 'none',
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                transition: 'background-color 0.3s',
              }}
              onClick={() => card.to && navigate(card.to)}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2c5364'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#203a43'}
            >
              {card.action}
            </button>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default Home;
